import { Grid } from "gridjs-react";
import "gridjs/dist/theme/mermaid.css";

export type DataTableColumn = string | { name: string; sort?: boolean; width?: string };

export interface DataTableProps {
  columns: DataTableColumn[];
  rows: (string | number | null)[][];
  pagination?: boolean;
  search?: boolean;
}

/**
 * Tabular widget. Maps to manifest chart_type=tabular. Wraps Grid.js
 * via gridjs-react.
 */
export default function DataTable(props: DataTableProps) {
  const { columns, rows, pagination = true, search = false } = props;
  return (
    <Grid
      data={rows}
      columns={columns}
      pagination={pagination ? { limit: 25 } : false}
      search={search}
      sort
      resizable
    />
  );
}
